@if (authService.hasPermission(Permission.ProductsFull)) {
  @if (displayMode === 'menu-item') {
    <button
      mat-menu-item
      (click)="onEdit()"
      >
      <mat-icon color="success">edit</mat-icon>
      <span>Edit</span>
    </button>
  }
  @if (displayMode === 'icon-button') {
    <button
      mat-icon-button
      color="success"
      matTooltip="Update"
      matTooltipPosition="above"
      (click)="onEdit()"
      >
      <mat-icon color="success">edit</mat-icon>
    </button>
  }
}
